export const PresetReductionDefaults = {
  V4: {
    minFavoriteWin: 1,
    maxFavoriteWin: 2,
    minUpsetWin: 1,
    maxUpsetWin: 2,
    minMajorUpsetWin: 0,
    maxMajorUpsetWin: 1,
    minStartNummerSum: 14,
    maxStartNummerSum: 40,
    minTop5Jockeys: 1,
    maxTop5Jockeys: 4,
    minBottom10Jockeys: 0,
    maxBottom10Jockeys: 1,
  },
  V5: {
    minFavoriteWin: 1,
    maxFavoriteWin: 2,
    minUpsetWin: 1,
    maxUpsetWin: 2,
    minMajorUpsetWin: 0,
    maxMajorUpsetWin: 1,
    minStartNummerSum: 17,
    maxStartNummerSum: 42,
    minTop5Jockeys: 1,
    maxTop5Jockeys: 5,
    minBottom10Jockeys: 0,
    maxBottom10Jockeys: 1,
  },
  V64: {
    minFavoriteWin: 2,
    maxFavoriteWin: 3,
    minUpsetWin: 1,
    maxUpsetWin: 2,
    minMajorUpsetWin: 0,
    maxMajorUpsetWin: 1,
    minStartNummerSum: 20,
    maxStartNummerSum: 52,
    minTop5Jockeys: 2,
    maxTop5Jockeys: 6,
    minBottom10Jockeys: 0,
    maxBottom10Jockeys: 1,
  },
  V65: {
    minFavoriteWin: 2,
    maxFavoriteWin: 3,
    minUpsetWin: 1,
    maxUpsetWin: 2,
    minMajorUpsetWin: 0,
    maxMajorUpsetWin: 1,
    minStartNummerSum: 20,
    maxStartNummerSum: 52,
    minTop5Jockeys: 2,
    maxTop5Jockeys: 6,
    minBottom10Jockeys: 0,
    maxBottom10Jockeys: 1,
  },
  V75: {
    minFavoriteWin: 2,
    maxFavoriteWin: 3,
    minUpsetWin: 1,
    maxUpsetWin: 2,
    minMajorUpsetWin: 0,
    maxMajorUpsetWin: 1,
    minStartNummerSum: 28,
    maxStartNummerSum: 58,
    minTop5Jockeys: 1,
    maxTop5Jockeys: 7,
    minBottom10Jockeys: 0,
    maxBottom10Jockeys: 1,
  },
  GS75: {
    minFavoriteWin: 2,
    maxFavoriteWin: 3,
    minUpsetWin: 1,
    maxUpsetWin: 2,
    minMajorUpsetWin: 0,
    maxMajorUpsetWin: 1,
    minStartNummerSum: 25,
    maxStartNummerSum: 50,
    minTop5Jockeys: 1,
    maxTop5Jockeys: 7,
    minBottom10Jockeys: 0,
    maxBottom10Jockeys: 1,
  },
  V86: {
    minFavoriteWin: 2,
    maxFavoriteWin: 4,
    minSecondFavoriteWin: 1,
    maxSecondFavoriteWin: 3,
    minUpsetWin: 1,
    maxUpsetWin: 2,
    minMajorUpsetWin: 0,
    maxMajorUpsetWin: 1,
    minStartNummerSum: 33,
    maxStartNummerSum: 63,
    minTop5Jockeys: 2,
    maxTop5Jockeys: 8,
    minBottom10Jockeys: 0,
    maxBottom10Jockeys: 1,
  },
};

export const RacesLength = {
  GS75: 7,
  V4: 4,
  V5: 5,
  V64: 6,
  V65: 6,
  V75: 7,
  V86: 8,
};

export const StartNrRange = {
  min: 0,
  max: 120,
};

export const Details = {
  percent: {
    V4: 35,
    V5: 30,
    V64: 35,
    V65: 30,
    V75: 25,
    GS75: 25,
    V86: 25,
  },
  median: {
    V4: 2500,
    V5: 6000,
    V64: 5500,
    V65: 7500,
    V75: 24_000,
    GS75: 17_000,
    V86: 35_000,
  },
  average: {
    V4: 5500,
    V5: 14_000,
    V64: 20_000,
    V65: 24_000,
    V75: 93_000,
    GS75: 58_000,
    V86: 600_000,
  },
};

export const Helper = {
  header: 'Om Snabbval',
  body: `<p>
    Med funktionen snabbval har du möjlighet att få en smart kraftfull
    reducering skapad för ditt system genom endast en knapptryckning (koppla
    på snabbval). Villkoren är satta utifrån statistiska faktorer hämtade
    från vår databas som innehåller information från ATG:s samtliga omgångar
    sedan 2010. De förinställda värdena kräver såväl att favoriter som någon
    överraskning vinner - precis som de flesta omgångar ser ut. Utöver det
    ställs villkor för de mest segervana/segerfattigaste kuskarna i
    omgången, samt summan av de vinnande hästarnas startnummer. Framförallt
    rekommenderar vi snabbvals-funktionen för dig som bara vill ta ut vilka
    hästar du vill spela med i omgången utan att ställa några egna
    reduceringsvillkor - samtidigt som du inte riktar in dig på att få alla
    rätt de mest favoritbetonade/mest osannolika omgångarna. Du kan själv
    välja att justera de förinställda värdena om du önskar.
  </p>
  <div className={styles.helperSubHeader}>
    Förklaring av de olika reduceringar som görs:
  </div>
  <p>
    <strong>Antal favoritsegrar</strong>: Favoriter avser de hästar i varje
    avdelning med högst insatsprocent vid inlämningstillfället.
  </p>
  <p>
    <strong>Antal andrahandsfavoriter</strong>: Andrahandsfavoriter avser de
    hästar i varje avdelning med näst högst insatsprocent vid
    inlämningstillfället. (Denna parameter finns endast med för V86).
  </p>
  <p>
    <strong>Antal skrällar</strong>: Skrällar avser de hästar på ditt system
    som är betrodda med max 10 procent vid inlämningstillfället.
  </p>
  <p>
    <strong>Antal storskrällar</strong>: Storskrällar avser de hästar på
    ditt system som är betrodda med max 5 procent vid inlämningstillfället.
  </p>
  <p>
    <strong>Startnummersumma</strong>: Startnummersumma avser totalen av
    vinnande hästars nummer i omgången. Om den rätta raden exempelvis är
    7-3-6-10-2-1-2 så är startnummersumman 31 (7+3+6+10+2+1+2). De
    förinställda värdena innebär väldigt låg risk för att spricka på detta
    krav sett till historiska omgångar.
  </p>
  <p>
    <strong>Antal kuskar med topp-5 högst segerprocent</strong>: Detta
    villkor avser hur många avdelningar som de 5 kuskar i omgången med högst
    segerprocent i Sverige nuvarande och föregående år tillsammans måste
    vinna. För att räknas med på topplistan måste kusken ha kört minst 50
    lopp under perioden. Aktuella kuskar för omgången listas under
    kusk-fliken.
  </p>
  <p>
    <strong>Antal kuskar med topp-10 lägst segerprocent</strong>: Detta
    villkor avser hur många avdelningar som de 10 kuskar i omgången med
    lägst segerprocent i Sverige nuvarande och föregående tillsammans får
    vinna. För att räknas med på topplistan måste kusken ha kört minst 50
    lopp under perioden. Aktuella kuskar för omgången listas under
    kusk-fliken.
  </p>
  <strong>
    OBS: Glöm inte att trycka på &quot;Uppdatera&quot; det sista du gör före
    inlämning av ditt system så att villkoren bygger på färsk speldata från
    ATG.
  </strong>`,
};
